import { SAVE_BINDING_BANK_CARD, SAVE_IS_PAY_PWD, SAVE_WALLET_PAY_PASSWORD, SAVE_DRAW_CASH_BANK_CARD } from '../mutation-types'

const initialState = {
  payPassword: null,
  bindingBankCard: null,
  isPayPassword: false,
  drawCashBankCard: null,
}

const mutations = {
  [SAVE_WALLET_PAY_PASSWORD](state, data) {
    state.payPassword = data
  },
  [SAVE_BINDING_BANK_CARD](state, data) {
    state.bindingBankCard = data
  },
  [SAVE_IS_PAY_PWD](state, data) {
    state.isPayPassword = data
  },
  [SAVE_DRAW_CASH_BANK_CARD](state, data) {
    state.drawCashBankCard = data
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/wallet.js